import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../core/auth/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  resetPasswordForm: FormGroup;
  token: string;
  loading: boolean;
  success: string;
  error: string;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private fb: FormBuilder,
              private authService: AuthService) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.token = params['token'];

      if (!this.token) {
        this.router.navigate(['/login']);
      }
    });

    this.resetPasswordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  submit(data) {
    this.loading = true;
    this.authService.resetPassword({token: this.token, password: data.password})
      .subscribe((res: any) => {
        this.loading = false;
        this.success = res.message;
      }, err => {
        this.loading = false;
        this.error = err.error.message || 'An error occurred';
      });
  }

}



// WEBPACK FOOTER //
// ./client/app/components/reset-password/reset-password.component.ts